<template lang="pug">
  .user-stats
    h2 Зарегистрированные пользователи
    users-table
</template>

<script>
import apiClient from '@/apiClient';
import UsersTable from '@/components/admin/UsersTable/UsersTable.vue';

export default {
  components: {
    UsersTable
  }
};
</script>
